/** See `src/i18n/locales/en/audit.ts`. */
export const audit = {
  page: {
    title: 'Audit-logboek',
    scopedLead:
      'Je ziet de toegestane acties voor je eigen bedrijven; toestemmingsantwoorden en identiteitskoppelingen worden nooit getoond.',
    actionFilter: 'Filteren op actie',
    actionPlaceholder: 'actie, bv. department.visibility.update',
    scopeFilter: 'Filteren op scope',
    scopePlaceholder: 'scope-id',
    filter: 'Filteren',
    empty: 'Geen auditregels.',
    when: 'Wanneer',
    action: 'Actie',
    actorRole: 'Rol van uitvoerder',
    target: 'Doel',
    rowsLabel: 'de auditregels',
  },
} as const;
